import React from 'react';
import "../styles/effects.css"

const NameFallingAnimation = () => {
  return (
    <div className="name-container">
      <div>
      Randall Rouse  
      </div>
      {/* <span className="falling-letter">R</span>
      <span className="falling-letter">a</span>
      <span className="falling-letter">n</span>
      <span className="falling-letter">d</span>
      <span className="falling-letter">a</span>
      <span className="falling-letter">l</span>
      <span className="falling-letter">l</span>
      <span className="falling-letter"> </span>
      <span className="falling-letter">R</span>
      <span className="falling-letter">o</span>
      <span className="falling-letter">u</span>
      <span className="falling-letter">s</span>
      <span className="falling-letter">e</span> */}
      <>  </>
      <span className="falling-letter">f</span>
      <span className="falling-letter">r</span>
      <span className="falling-letter">o</span>
      <span className="falling-letter">n</span>
      <span className="falling-letter">t</span>
      <span className="falling-letter">e</span>
      <span className="falling-letter">n</span>
      <span className="falling-letter">d</span>
      <span className="falling-letter"> </span>
      <span className="falling-letter">d</span>
      <span className="falling-letter">e</span>
      <span className="falling-letter">v</span>
      <span className="falling-letter">e</span>
      <span className="falling-letter">l</span>
      <span className="falling-letter">o</span>
      <span className="falling-letter">p</span>
      <span className="falling-letter">e</span>
      <span className="falling-letter">r</span>
    </div>
  );
};

export default NameFallingAnimation;
